import React from "react";
import { ListItem, ListItemIcon, ListItemText, Tooltip, Hidden, Badge } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import {
  VpnKey,
  Inbox,
  Send,
  Create,
  Description,
  LocalLibrary
} from "@material-ui/icons";
import { Link } from "react-router-dom";
import pathName from "../PathToName";
import { Permission } from "../img"

const styles = theme => ({
  default: {
    backgroundColor: theme.palette.secondary.main
  },
  FonTooltip:{
    fontSize: 12
  }
});

class AuthItems extends React.Component {
  setProps = l => {
    const props = { to: l };
    let currPath = window.location.pathname;
    if (currPath === "/") currPath = "/recibidos";
    if (currPath === l) props.className = this.props.classes.default;
    return props;
  };

  render() {

    const { onClose, classes, can_create, isDelegate, badges, isReviewer } = this.props;

    let menu = (
      <Element
        title="Oficios recibidos"
        classes={classes}
        section={pathName("/recibidos")}
        url={"/recibidos"}
        icon={<Inbox/>}
        badge
        badges={badges.inbox}/>
    );

    if(can_create === "true" || isDelegate === true){
      menu = (
        <div>
         <Hidden xsDown >
           <Element
             title="Crear nuevo oficio"
             classes={classes}
             section={pathName("/oficios/new")}
             url={"/oficios/new"}
             icon={<Create/>}/>
        </Hidden>
        <Element
          title="Oficios recibidos"
          classes={classes}
          section={pathName("/recibidos")}
          url={"/recibidos"}
          icon={<Inbox/>}
          badge
          badges={badges.inbox}/>
         <Hidden xsDown>
           <Element
             title="Borradores"
             classes={classes}
             section={pathName("/borradores")}
             url={"/borradores"}
             icon={<Description/>}/>
         </Hidden>
         <Element
           title="Oficios enviados"
           classes={classes}
           section={pathName("/enviados")}
           url={"/enviados"}
           icon={<Send/>}/>
          <Hidden xsDown >
            <Element
              title="Configuraciones"
              classes={classes}
              section={pathName("/configuraciones")}
              url={"/configuraciones"}
              icon={<Permission/>}/>
          </Hidden>
        </div>
      );
    }

      if(can_create === "false" && isReviewer === true && isDelegate === false){
        menu = (
          <div>
          <Element
            title="Oficios recibidos"
            classes={classes}
            section={pathName("/recibidos")}
            url={"/recibidos"}
            icon={<Inbox/>}
            badge
            badges={badges.inbox}/>
           <Element
             title="Oficios enviados"
             classes={classes}
             section={pathName("/enviados")}
             url={"/enviados"}
             icon={<Send/>}/>
          </div>
        );
      }

    return (
      <div onClick={onClose} data-tut="sidebar">
        {menu}
        <Element
          title="Manuales"
          classes={classes}
          section={pathName("/manuales")}
          url={"/manuales"}
          icon={<LocalLibrary/>}
          badge
          badges={badges.inbox}/>
      </div>
    );
  }
}

const SideMenuItems = ({ isAuth, onClose, classes, can_create, isDelegate, badges, isReviewer }) => {
  if (isAuth){
    return (
      <AuthItems
        onClose={onClose}
        classes={classes}
        can_create={can_create}
        isDelegate={isDelegate}
        isReviewer={isReviewer}
        badges={badges} />
    );
  }
  else{
    return (
      <div>
        <ListItem component={Link} to="/login" button>
          <ListItemIcon>
            <VpnKey />
          </ListItemIcon>
          <ListItemText primary="Ingresar" />
        </ListItem>
      </div>
    );
  }
};

const Element = (props) =>{
  return(
    <Tooltip classes={{ tooltip: props.classes.FonTooltip }}
      title={props.title}
      placement="right"
      enterDelay={500}
      leaveDelay={200}>
        <ListItem component={Link} to={props.url} button>
          <ListItemIcon>
            {props.badge? (<Badge badgeContent={props.badges} color="primary">{props.icon}</Badge>) : props.icon}
          </ListItemIcon>
        <ListItemText primary={props.section} />
        </ListItem>
    </Tooltip>
  )
}

export default withStyles(styles, { withTheme: true })(SideMenuItems);



// WEBPACK FOOTER //
// ./src/components/SideMenuItems.js